// extracted by mini-css-extract-plugin
export default {"loadingContainer":"ReportDataDisplay_loadingContainer__tVnCZ","noDataContainer":"ReportDataDisplay_noDataContainer__JIrSw"};